<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "CustomerApplyingVoid"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApplyingVoid.vue